<template>
  <div class="row suppliers-adder">
    <div
      class="col-sm-12 col-md-6 col-lg-6 col-xl-4 m-auto suppliers-adder-form"
    >
      <div>
        <div v-for="(k, key) in dropLast" :key="key">
          <div class="form-group row">
            <label class="col-sm-4 form-label text-primary_2">{{
              $t("supplier." + k)
            }}</label>
            <div class="col-sm-8">
              <input
                @keyup.enter="addSupplier"
                class="form-control form-control-sm"
                v-model="supplier[k]"
                :placeholder="$t('supplier.' + k)"
                @focus="dirty[k] = true"
                :class="{
                  'is-invalid': dirty[k] && validation[k] === false,
                  'is-valid': validation[k],
                }"
              />
            </div>
          </div>
        </div>
        <div>
          <div class="form-group row">
            <label class="col-sm-4 form-label text-primary_2">{{
              $t("supplier.countryCode")
            }}</label>
            <div class="col-sm-8">
              <select
                @keyup.enter="addSupplier"
                class="form-control form-control-sm col"
                v-model="supplier.countryCode"
                @focus="dirty.countryCode = true"
                :class="{
                  'is-invalid': dirty.countryCode && !validation.countryCode,
                  'is-valid': validation.countryCode,
                }"
              >
                <option value="" disabled selected>
                  {{ $t("supplier.countryCode") }}
                </option>
                <option
                  v-for="(cc, key) in countrycodes"
                  :key="key"
                  :value="cc.value"
                >
                  {{ cc.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <div class="form-group row">
            <label class="col-sm-4 form-label text-primary_2">{{
              $t("supplier.language")
            }}</label>
            <div class="col-sm-8">
              <select
                @keyup.enter="addSupplier"
                class="form-control form-control-sm col"
                v-model="supplier.language"
                @focus="dirty.language = true"
                :class="{
                  'is-invalid': dirty.language && !validation.language,
                  'is-valid': validation.language,
                }"
              >
                <option value="" disabled selected>
                  {{ $t("supplier.language") }}
                </option>
                <option value="fi_FI">FI</option>
                <option value="en_US">EN</option>
                <option value="sv_SE">SV</option>
              </select>
            </div>
          </div>
        </div>
        <button @click="addSupplier" class="btn btn-success float-right">
          {{ $t("supplier.add") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { countrycodes } from "../../assets/countrycodes";
import { validateYtunnus } from "../../utils";
export default {
  data() {
    return {
      supplier: {
        businessId: "",
        name: "",
        email: "",
        street1: "",
        street2: "",
        postOffice: "",
        postalCode: "",
        language: "",
        countryCode: "",
      },
      dirty: {
        businessId: false,
        language: false,
      },
      validation: {
        businessId: false,
        language: false,
      },
      languages: [
        { value: "fi_FI", name: "FI" },
        { value: "sv_SE", name: "SV" },
        { value: "sv_SE", name: "SE" },
      ],
      countrycodes,
    };
  },
  methods: {
    validate: function () {
      let valid = true;
      Object.keys(this.validation).forEach((k) => {
        this.dirty[k] = true;
        if (!this.validation[k]) {
          valid = false;
        }
      });
      return valid;
    },
    addSupplier: async function () {
      if (this.validate()) {
        try {
          let res = await this.$store.dispatch("addSupplier", this.supplier);
          this.$emit("add", [res]);
          this.$notify({
            text: this.$t("supplier.addedSupplier"),
            type: "success",
            duration: 1000,
          });
          Object.keys(this.supplier).forEach((k) => {
            this.supplier[k] = "";
            this.dirty[k] = false;
          });
        } catch (error) {
          console.log(error);
          this.$notify({
            type: "error",
            text: this.$t("supplier.operationFailed"),
            duration: 1000,
          });
        }
      } else {
        this.$notify({
          type: "error",
          text: this.$t("supplier.checkForm"),
          duration: 1000,
        });
      }
    },
    simpleValidate: function (val) {
      return val.length > 0;
    },
  },
  watch: {
    "supplier.businessId": async function (val) {
      if (val.length > 0) {
        try {
          if (validateYtunnus(val)) {
            let data = await this.$store.dispatch("queryYTJ", val);
            if (!data.YritysLopetettu) {
              this.supplier.name = data.Toiminimi;
              this.supplier.street1 = data.YrityksenPostiOsoite.Katuosoite;
              this.supplier.postalCode = data.YrityksenPostiOsoite.Postinumero;
              this.supplier.postOffice = data.YrityksenPostiOsoite.Toimipaikka;
              this.supplier.countryCode = data.YrityksenPostiOsoite.Maakoodi;
              let language = this.languages.find(
                (l) => l.name === data.YrityksenPostiOsoite.Maakoodi
              );
              this.supplier.language = language.value || "";
            }
          }
        } catch (error) {
          console.log(error);
        }
        this.validation.businessId = true;
      } else {
        this.validation.businessId = false;
      }
    },
    "supplier.name": function (val) {
      this.validation.name = this.simpleValidate(val);
    },
    "supplier.postalCode": function (val) {
      this.validation.postalCode = this.simpleValidate(val);
    },
    "supplier.postOffice": function (val) {
      this.validation.postOffice = this.simpleValidate(val);
    },
    "supplier.countryCode": function (val) {
      this.validation.countryCode = this.simpleValidate(val);
    },
    "supplier.street1": function (val) {
      this.validation.street1 = this.simpleValidate(val);
    },
    "supplier.language": function (val) {
      this.validation.language = this.simpleValidate(val);
    },
    "supplier.email": function (val) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.validation.email = re.test(val);
    },
  },
  computed: {
    dropLast: function () {
      let keys = Object.keys(this.supplier);
      return keys.slice(0, keys.length - 2);
    },
  },
};
</script>

<style scoped>
.suppliers-adder-form {
  max-width: 550px;
}
.suppliers-adder {
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(150, 202, 212, 0.2);
}
.text-button {
  background: none;
  border: none;
  color: #fff;
}
.text-button:hover {
  text-decoration: underline;
}
</style>
